<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        login
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">Log</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">login</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-card>
        <b-col lg="12" xl="12">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Log Detail
            </div>
            <div class="mb7">
              <span class="float-right">Date : {{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <pre>{{model}}</pre>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Attacker</label><br></b>
                <!-- <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.remote_addr}}</label> -->
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>Target</label><br></b>
                <!-- <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.target}}</label> -->
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-col>
      </b-card>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';

export default {
  data : () => {
    return {
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_login'}); },
    async get( id = this.$route.params) {
      console.log('log.login.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('log.login', 'detail', { id : Number(id.id) })

        console.info(rs)
        this.model = rs.body;
        // let rr = await Api.Manager_Call('user', '')
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.login.detail.vue', 'created'); },
  destroyed() { console.log('log.login.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.login.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
